// The price-lock rules behind the Stock:AdminOnlyChanges setting, mirroring the API's
// StockPermissionRules so the dashboard locks exactly the prices the API would refuse to move.

// The price a listing already sells at: the offer's own price, or the part's entered price
// when the offer has none - so a part priced in stock can't be listed for less.
export const baselinePrice = (offerPrice?: number | null, enteredPrice?: number | null): number | null => {
  if (offerPrice != null && offerPrice > 0) return offerPrice;
  return enteredPrice ?? null;
};

// A restricted user can set a first price but can't move one that's already set.
export const isPriceLocked = (restricted: boolean, price?: number | null): boolean =>
  restricted && price != null && price > 0;
